module.exports = __webpack_public_path__ + "img/map-GERMANY-de.f162bfc1.png";